import React, { useRef, useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import mapboxgl from '!mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

const Globe = ({ countries = [] }) => {
  

  const refMapContainer = useRef(null);
  const refMap = useRef(null);

  useEffect(() => {

    if (refMap.current) return;

    mapboxgl.accessToken =
      "pk.eyJ1Ijoib3V0bGF3b2NlYW4iLCJhIjoiY2xkbjhjYjJpMDVwMTNwdXU0N2tvZ2x2eiJ9.7_WEsb9rOIbSxk7_UUzyzQ"
    
    const mediaQuery = window.matchMedia('(max-width: 48em)');
    const center = mediaQuery.matches ? [0,20] : [0,40];
    const zoom = mediaQuery.matches ? 0 : 1;
    

    refMap.current = new mapboxgl.Map({
      bearing: 0, // 82
      container: refMapContainer.current,
      center: center,
      //dragPan: false,
      //interative: false,
      //keyboard: false,
      scrollZoom: false,
      style: "mapbox://styles/outlawocean/cldn91hvl00d201o9di7mspt6",
      pitch: 0, // 60
      zoom: zoom, // 6
      projection: "globe",
      attributionControl: false,
    });

    let map = refMap.current;
    
    map.on('load', () => {

      countries.forEach(( country ) => {
        
        /*const rippleEl = document.createElement('b');
        
        rippleEl.classList.add('map-ripple');
        rippleEl.innerHTML = `<span></span>`;
        
        
        new mapboxgl.Marker({ 
          element: rippleEl,
          rotationAlignment: 'horizon',
          offset: [0, -(80/100) / 2]
        })
          .setLngLat(country.coordinates.coordinates)
          .addTo(map);
          
        const pinEl = document.createElement( 'div' );
        pinEl.classList.add( 'map-pin' );

        new mapboxgl.Marker({ 
          element: pinEl,
          rotationAlignment: 'horizon',
          offset: [0, -(16/100) / 2]  
        })
          .setLngLat(country.coordinates.coordinates)
          .addTo(map);
        */


          new mapboxgl.Marker({ 
            rotationAlignment: 'horizon',
            offset: [0, -(16/100) / 2]  
          })
            .setLngLat(country.coordinates.coordinates)
            .addTo(map);
        
      });
    });
    
    // The following values can be changed to control rotation speed:

    // At low zooms, complete a revolution every two minutes.
    const secondsPerRevolution = 40;
    // Above zoom level 5, do not rotate.
    const maxSpinZoom = 5;
    // Rotate at intermediate speeds between zoom levels 3 and 5.
    const slowSpinZoom = 3;

    let userInteracting = false;
    let spinEnabled = true;

    function spinGlobe() {
      let map = refMap.current;
        const zoom = map.getZoom();
        if (spinEnabled && !userInteracting && zoom < maxSpinZoom) {
            let distancePerSecond = 360 / secondsPerRevolution;
            if (zoom > slowSpinZoom) {
                // Slow spinning at higher zooms
                const zoomDif =
                    (maxSpinZoom - zoom) / (maxSpinZoom - slowSpinZoom);
                distancePerSecond *= zoomDif;
            }
            const center = map.getCenter();
            center.lng -= distancePerSecond;
            // Smoothly animate the map over one second.
            // When this animation is complete, it calls a 'moveend' event.
            map.easeTo({ center, duration: 1000, easing: (n) => n });
        }
    }

    // Pause spinning on interaction
    map.on('mousedown', () => {
        userInteracting = true;
    });

    // Restart spinning the globe when interaction is complete
    map.on('mouseup', () => {
        userInteracting = false;
        spinGlobe();
    });

    // These events account for cases where the mouse has moved
    // off the map, so 'mouseup' will not be fired.
    map.on('dragend', () => {
        userInteracting = false;
        spinGlobe();
    });
    map.on('pitchend', () => {
        userInteracting = false;
        spinGlobe();
    });
    map.on('rotateend', () => {
        userInteracting = false;
        spinGlobe();
    });

    // When animation is complete, start spinning if there is no ongoing interaction
    map.on('moveend', () => {
        spinGlobe();
    });
    /*
    document.getElementById('btn-spin').addEventListener('click', (e) => {
        spinEnabled = !spinEnabled;
        if (spinEnabled) {
            spinGlobe();
            e.target.innerHTML = 'Pause rotation';
        } else {
            map.stop(); // Immediately end ongoing animation
            e.target.innerHTML = 'Start rotation';
        }
    });
    */
    spinGlobe();
    
  },[]);

  return (
      <StyledMapContent id="map" ref={refMapContainer} />
  )
};

export default Globe;




const pulse = keyframes`
  0% {
    transform: scale(0.2);
    opacity: 0;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
`


const StyledMapContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /*
  &::after {
    content: '';
    position: absolute;
    display: block;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 5;
  }
  */
  .map-ripple span {
    position: absolute;
    z-index: 1;
    display: block;
    height: 5em;
    width: 5em;
    border-radius: 50%;
    top: 50%;
    left: 50%;
    margin-left: -2.5em;
    margin-top: -2.5em;
    opacity: 0;
    color: var(--theme-text-against-dark);
    animation: ${pulse} 4s ease-in-out infinite;
    @media ( max-width: 48em ) {
      height: 5em;
      width: 5em;
      margin-left: -2.5em;
      margin-top: -2.5em;
    }
    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      opacity: 0.3;
      border-radius: inherit;
      background-color: rgba(244, 244, 245, 0.8);
      background-image: repeating-radial-gradient(circle, currentColor, currentColor 1px, transparent 1px, transparent 4px);
    }
    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border: 1px solid currentColor;
      opacity: 0.7;
      border-radius: inherit;
    }
  }
  .map-ripple:nth-of-type(2n) span {
    animation-delay: 2.625s;
  }
  .map-ripple:nth-of-type(4n) span {
      animation-delay: 1.375s;
  }
  .map-ripple:nth-of-type(3n) span {
      animation-delay: .75s;
  }

  .map-pin {
    font-size: 1rem;
    z-index: 2;
    &::before {
      content: '';
      postion: absolute;
      display: block;
      height: 1em;
      width: 1em;
      border-radius: 50%;
      background-color: var(--theme-text-against-light);
      box-shadow: inset 0 0 0 0.375em var(--theme-text-against-dark), 0 0 2em rgba(0,0,0,0.2);
      cursor: pointer;
      transition: transform 0.2s ease;
      transform: scale(0.5) translate3d(0,0,0);
    }
    /*.can-hover &:hover::before {
      transform: scale(1) translate3d(0,0,0);
    }*/
  }

`
